const DataAdder = (props) => {
    return (
        <>
            <div className="data_input">
                <input type="text" onChange={props.change} value={props.info} placeholder={props.placeholderText} />
                <button onClick={props.click} title="Add">+</button>
            </div>
        </>
    );
}
export default DataAdder;